(function(){

    /*
    * Inizializzazione Swiper.js
    * */
    var swiper = new Swiper(".historySwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            "1200": {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });

    var swiper = new Swiper(".aboutSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "991": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
        },
    });

    var swiper = new Swiper(".partnerSwiper", {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                spaceBetween: 50,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 80,
            },
            "1200": {
                slidesPerView: 4,
                spaceBetween: 80,
            },
        },
    });

    var swiper = new Swiper(".awardsSwiper", {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 50,
            },
            "992": {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 80,
            },
            "1200": {
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 80,
            },
        },
    });

})();
